import React, { useState, useEffect } from 'react'
import { MDBTable, MDBTableBody, MDBTableHead, MDBContainer, MDBRow, MDBCol, MDBBtn, MDBInput } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit, faBarcode, faPrint, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import moment from 'moment'
import Header from '../componentes/Header';
import SubirProductos from './SubirProductos'
import AgregarImagenes from '../componentes/AgregarImagenes'
import useTraeDatos from '../hooks/useTraeDatos'
import { traeIdNombre, TraeNombre } from '../hooks/Funciones'
import EliminarProducto from './productos/EliminarProducto'
import VerProductos from './productos/VerProductos'
import Paginacion from './productos/Paginacion'
import { useRef } from 'react';
import ProductosBarcode from './productos/ProductosBarcode';
import { useReactToPrint } from 'react-to-print';
import ImprimirProductos from './ImprimirProductos';
import { jsonrepair } from 'jsonrepair';
import { FieldsProductosCombos } from './productos/FieldsProductosCombos';
import { uid } from 'uid';
import InventarioProductosConfiguracion from './productos/InventarioProductosConfiguracion';
import { imagenDefault } from '../hooks/imagenDefault';
import { downloadExcel } from "react-export-table-to-excel";


const ProductosAdmin = ({ baseURLInventarios, baseUrl, baseUrlCursos, nombreImpuesto, urlCat, urlAtributos, Titulo }) => {

	const [cursos, setCursos] = useTraeDatos(baseUrlCursos)
	const [productoSelect, setProductoSelect] = useState({})
	const [imagenPermanente, setImagenPermanente] = useState('')
	const [data, setData] = useState([])
	const [copiaArray, setCopiaArray] = useState([])
	const [busqueda, setBusqueda] = useState('')
	const [tituloPag, setTituloPag] = useState(Titulo)
	const [imagenes, setImagenes] = useState([])
	const [imagenesViejas, setImagenesViejas] = useState([])
	const [productosBarcode, setProductosBarcode] = useState([])
	const [imagenesNuevas, setImagenesNuevas] = useState(false)
	const [borraImagenes, setBorraImagenes] = useState(false)
	const [productosEnCombo, setProductosEnCombo] = useState([{
		"id": uid(),
		"cantidad": null,
		"producto": null,
		"atributos": null,
		"opciones": null
	}])

	const [checkCombos, setCheckCombos] = useState(false)
	const [dataFiltrado, setDataFiltrado] = useState([])
	const PAGINACION = 15
	const [numPaginas, setNumPaginas] = useState()
	const [numRegistros, setNumRegistros] = useState()
	const [paginaAct, setPaginaAct] = useState(1);
	const [checkDescuentoCupones, setCheckDescuentoCupones] = useState(false)
	const [checkInvent, setCheckInvent] = useState(false)
	const refImprimirProductos = useRef()

	const [visualizacionState, setVisualizacionState] = useState([])

	//const {loading, data, error} = useConsultaDatos(baseUrl)
	const [funcion, setFuncion] = useState('cargando')
	const [alerta, setAlerta] = useState(0)

	const [cargandoBoton, setCargandoBoton] = useState(false)
	const [atributosEliminados, setAtributosEliminados] = useState([])


	const handleDownloadExcel = () => {

		const columns = ["id","referencia", "producto", "precio", "categorias", "inventario"]

		let dataExport = []
		data.map((item) => {
			item['categorias'] = imprimeArray(item.categoria_producto, true)
			item['precio'] = item.precio_rebajado > 0 ? item.precio_rebajado.toString() : item.precio_producto.toString()
			item['inventario'] = item.inventarioCantidad
			item['producto'] = item.nombre_producto
			item['id'] = item.id
			let items = new Object();
			columns.map(col => {
				items[col] = item[col]
			})
			dataExport.push(items)
		})

		downloadExcel({
			fileName: "productos bluemoon",
			sheet: "productos",
			tablePayload: {
				header: columns,
				body: dataExport,
			},
		});
		console.log(dataExport)

	}

	//hace la consulta y trae las categorias y los almacena en data 
	const peticionTraeDatos = () => {
		//trae prodcutos con sus atibutos independientes:
		axios.get(baseUrl, { params: { atributos: 'true' } })

			.then(response => {
				let respuesta = response.data

				let newArr = []

				respuesta.map((item) => {
					newArr.push({
						...item,
						imagenesNuevas: '',
						activo: item.activo === "true" ? true : false,
						categoria_producto: JSON.parse(jsonrepair(item.categoria_producto)),
						atributos: JSON.parse(jsonrepair(item.atributos)),
						url_imagen: JSON.parse(jsonrepair(item.url_imagen)),
						imagePrev: item.url_imagen,
					})
				})
				newArr.sort(function (a, b) {
					return b.id - a.id;
				});



				setData(newArr)
				setCopiaArray(newArr)
				eliminarRepetidos(newArr)
				setDataFiltrado([...newArr].splice(0, PAGINACION))
				setNumPaginas(Math.ceil(newArr.length / PAGINACION))
				setNumRegistros(newArr.length)
				setFuncion('ver')

			})

		axios.get(urlCat)
			.then(response => {
				setCategorias(response.data)
			})

		axios.get(urlAtributos)
			.then(response => {
				setAtributos(response.data)
			})
	}

	const eliminarRepetidos = (data) => {
		const nombresUnicos = data.filter((obj, index, self) =>
			index === self.findIndex((t) => (
				t.nombre_producto === obj.nombre_producto
			))
		);
		setProductosBarcode(nombresUnicos)
	};

	const peticionDelete = () => {
		let f = new FormData();
		f.append("METHOD", "DELETE");

		console.log('borrará imagenes')
		let ArayBorraImagenes = []
		imagenesViejas.map(item => { ArayBorraImagenes.push(item.nombre_imagen) })
		f.append('arrayBorraImagenes', JSON.stringify(ArayBorraImagenes))
		console.log('imagens a borrar:', JSON.stringify(ArayBorraImagenes))

		axios.post(baseUrl, f, { params: { id: productoSelect.id } })
			.then(response => {
				setData(data.filter(producto => producto.id !== productoSelect.id))
				setDataFiltrado(dataFiltrado.filter(producto => producto.id !== productoSelect.id))
				setFuncion('ver')
			}).catch(error => {
				console.log(error)
			})
	}

	const seleccionaProducto = (producto, funcion) => e => {
		setProductoSelect({ ...producto, curso: TraeNombre(cursos, producto.id_curso), impuesto_producto: nombreImpuesto })

		setVisualizacionState(JSON.parse(producto.visualizacion))
		let array = []
		producto.url_imagen.map(item => {
			array.push({
				nombre_imagen: item.nombre_imagen,
				imagePrev: `${baseUrl}${item.nombre_imagen}`
			})
		})

		setCheckInvent(String(producto.inventario) == "true" ? true : false)

		setCheckCombos(String(producto.combo) == "true" ? true : false)

		setCheckDescuentoCupones(String(producto.descuentoCupones) == "true" ? true : false)

		setImagenes(array)
		setImagenesViejas(array)
		setFuncion(funcion)
		if (String(producto.combo) == "true") {
			setProductosEnCombo(producto.atributos)
		}
		setAlerta(producto.alerta)
	}

	const imprimeArray = (array, optimiza) => {

		let resultado = ''
		array.map(item => {
			categorias.map(ite => {
				if (ite.id === item) { resultado = ite.nombre + ", " + resultado }
			})
		})

		if (optimiza) {
			resultado = resultado.slice(0, 20);
			return `${resultado}...`
		}
		else { return resultado }
	}

	const imprimeAtribut = (array, optimiza) => {
		let resultado = ''
		array && array.length > 0 && array.map(item => {
			let precio = item.precio === undefined ? '' : item.precio
			if (item.opcion !== undefined) {
				resultado = `(${item.opcion} $${precio}) ${resultado} `
			}
		})

		if (optimiza) {
			resultado = resultado.slice(0, 20);
			return `${resultado}...`
		}
		else { return resultado }
	}

	const consultaCategoria = (array, nombre) => {

		//convirte cadena en array
		let newArr = productoSelect.categoria_producto
		//devuelve true o false si lo encuentra
		return newArr.some(n => n === nombre)

	}

	//Trae todas las categorias de la api
	useEffect(() => {
		peticionTraeDatos()
	}, [])


	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------


	const [atributoSelect, setAtributoSelect] = useState({
		nombre: '',
		opciones: [""],
		limite: null,
		multiple: ''
	})
	const [categorias, setCategorias] = useState([])
	const [atributos, setAtributos] = useState([])

	const [producto, setProducto] = useState({
		activo: true,
		nombre: '',
		precio: 0,
		rebajado: 0,
		imagen: null,
		imagePrev: null,
		impuesto: '',
		categorias: ['todo'],
		atributos: []
	})

	const subeCategorias = (cate, index) => e => {

		let Categorias = productoSelect.categoria_producto

		Categorias.map((itemm, index) => {
			if (itemm === cate) {
				let newArr = Categorias
				let index = newArr.indexOf(cate);
				if (index > -1) { newArr.splice(index, 1); }

				setProductoSelect({ ...productoSelect, categoria_producto: newArr })

			} else {
				setProductoSelect({ ...productoSelect, categoria_producto: [...productoSelect.categoria_producto, cate] })
			}
		})

	}

	const [error, setError] = useState({
		activo: false,
		mensaje: 'Hola'
	})

	const errores = codigo => {
		switch (codigo) {
			case 'CampoVacio':
				setError({ activo: true, mensaje: 'Hay campos vacios' })
				break
			case 'Precio':
				setError({ activo: true, mensaje: 'El Campo Precio debe ser diferente al de reabaja' })
				break
			case 'Imagen':
				setError({ activo: true, mensaje: 'El archivo pesa más de 2mb o tiene un formato no admitido' })
				break
			case 'Limpio':
				setError({ activo: false, mensaje: '' })
				break

		}
	}

	const ValidaImagenes = () => {
		let resultado = false
		let formatosPermitidos = ['.png', '.jpeg', '.jpg']

		imagenes.map(item => {
			if (item.imagen !== undefined) {
				let formato = item.imagen.type.replace('image/', '.');

				if (formatosPermitidos.includes(formato)) {
					if (item.imagen.size >= 2000000) { resultado = true }
				} else { resultado = true }
			}
		})
		return resultado
	}

	const PreparaImagenes = async () => {
		const fecha = moment(new Date()).format("YYYYMMDD-HHmmss");
		let RutaServ = 'images/'

		let array = []

		const imagenesArray = [...imagenes]
		if (imagenes.length == 0) {
			const imagen = await imagenDefault()
			imagenesArray.push({ imagePrev: URL.createObjectURL(imagen), imagen, nueva: true })
		}
		setImagenes(imagenesArray)

		imagenesArray.map(item => {
			if (item.imagen !== undefined) {
				let NombreImagen = item.imagen.name.replace(/[^A-Z0-9]+/ig, "_");
				let formato = item.imagen.type.replace('image/', '.');
				array.push({
					imagen: item.imagen,
					nombre_imagen: RutaServ + fecha + NombreImagen + formato,
					nueva: item.nueva ? true : false
				})
			} else { array.push(item) }
		})
		return array

	}

	const PreparaImagenesString = async () => {
		const fecha = moment(new Date()).format("YYYYMMDD-HHmmss");
		let RutaServ = 'images/'

		let array = []

		const imagenesArray = [...imagenes]
		if (imagenes.length == 0) {
			const imagen = await imagenDefault()
			imagenesArray.push({ imagePrev: URL.createObjectURL(imagen), imagen, nueva: true })
		}

		imagenesArray.map(item => {
			let NombreImagen = item.imagen.name.replace(/[^A-Z0-9]+/ig, "_");
			let formato = item.imagen.type.replace('image/', '.');
			array.push({
				nombre_imagen: RutaServ + fecha + NombreImagen + formato
			})
		})
		return array
	}

	const peticionPut = async () => {
		setCargandoBoton(true)
		const imaLista = 'images/' + imagenPermanente

		let { id, referencia, activo, tipo, curso, nombre_producto, atributos, precio_producto, carga, precio_rebajado, url_imagen, impuesto_producto, categoria_producto, descripcion, descuentouser } = productoSelect
		let IdCurso = traeIdNombre(cursos, curso)

		if (nombre_producto !== '' && impuesto_producto !== '' && precio_producto > 0) {
			if (precio_rebajado !== precio_producto) {
				if (imagenesNuevas === false) {
					console.log('sin cambio en IMAGENES')

					//cuando se va a subir la misma imagen

					let f = new FormData()
					f.append('id', id)
					f.append('activo', activo.toString())
					f.append('tipo', tipo)
					f.append('id_curso', IdCurso)
					f.append('nombre', nombre_producto)
					f.append('precio', precio_producto)
					f.append('rebajado', precio_rebajado)
					f.append('imagenes', JSON.stringify(url_imagen))
					f.append('impuesto', impuesto_producto)
					f.append('categoria', JSON.stringify(categoria_producto))
					if (checkCombos) {
						f.append('atributos', JSON.stringify(productosEnCombo))
					} else {
						f.append('atributos', JSON.stringify(atributos))

					}

					f.append('inventario', checkInvent)
					f.append('alerta', alerta)
					f.append('carga', carga)
					f.append('descripcion', descripcion)
					f.append('descuentouser', descuentouser)
					f.append('descuentoCupones', checkDescuentoCupones)
					f.append('visualizacion', JSON.stringify(visualizacionState))
					f.append('combo', checkCombos)
					f.append('referencia', referencia)
					f.append('atributosEliminados', JSON.stringify(atributosEliminados))
					f.append('METHOD', 'PUT')

					await axios.post(baseUrl, f)

						.then(response => {
							//console.log(respuesta)
							peticionTraeDatos()
							setFuncion('ver')
							console.log('enviado')
							errores('Limpio')
							setCargandoBoton(false)
							setAtributosEliminados([])
						}).catch(error => {
							console.log('muestra erro: ' + error);
							setCargandoBoton(false)
						})

				} else if (imagenesNuevas === true) {

					if (!ValidaImagenes()) {
						//cuando se va a subir una imagen nueva
						console.log('NUEVAS IMAGENES')

						let ImagenesListas = await PreparaImagenes()
						let ImagenesListasString = await PreparaImagenesString()

						let f = new FormData()
						f.append('id', id)
						f.append('activo', activo.toString())
						f.append('tipo', tipo)
						f.append('id_curso', IdCurso)
						f.append('nombre', nombre_producto)
						f.append('precio', precio_producto)
						f.append('rebajado', precio_rebajado)
						f.append('impuesto', impuesto_producto)
						f.append('categoria', JSON.stringify(categoria_producto))

						if (checkCombos) {
							f.append('atributos', JSON.stringify(productosEnCombo))
						} else {
							f.append('atributos', JSON.stringify(atributos))
						}
						f.append('combo', checkCombos)
						f.append('descripcion', descripcion)
						f.append('carga', carga)
						f.append('descuentouser', descuentouser)
						f.append('METHOD', 'PUT')
						f.append('visualizacion', JSON.stringify(visualizacionState))
						f.append('descuentoCupones', checkDescuentoCupones)
						f.append('inventario', checkInvent)
						f.append('imagenes', JSON.stringify(ImagenesListasString))
						f.append('imagenesNuevas', 'true')
						f.append('alerta', alerta)
						f.append('imagen0', ImagenesListas[0].imagen)
						f.append('imagen0_nombre', ImagenesListas[0].nombre_imagen)
						f.append('referencia', referencia)
						f.append('atributosEliminados', JSON.stringify(atributosEliminados))
						f.append('combo', checkCombos)

						if (ImagenesListas[1] !== undefined) {
							f.append('imagen1', ImagenesListas[1].imagen)
							f.append('imagen1_nombre', ImagenesListas[1].nombre_imagen)
						}
						if (ImagenesListas[2] !== undefined) {
							f.append('imagen2', ImagenesListas[2].imagen)
							f.append('imagen2_nombre', ImagenesListas[2].nombre_imagen)
						}
						if (ImagenesListas[3] !== undefined) {
							f.append('imagen3', ImagenesListas[3].imagen)
							f.append('imagen3_nombre', ImagenesListas[3].nombre_imagen)
						}

						if (borraImagenes) {
							console.log('borrará imagenes')
							let ArayBorraImagenes = []
							imagenesViejas.map(item => { ArayBorraImagenes.push(item.nombre_imagen) })
							f.append('arrayBorraImagenes', JSON.stringify(ArayBorraImagenes))
							console.log('imagens a borrar:', JSON.stringify(ArayBorraImagenes))
						}

						await axios.post(baseUrl, f)

							.then(response => {
								const respuesta = response.data
								console.log(respuesta)
								peticionTraeDatos()
								setFuncion('ver')
								console.log('enviado')
								errores('Limpio')
								setImagenesNuevas(false)
								setBorraImagenes(false)
								setCargandoBoton(false)
								setAtributosEliminados([])
							}).catch(error => {
								console.log('muestra erro: ' + error);
								setCargandoBoton(false)
							})
					} else {
						errores('Imagen')
						setCargandoBoton(false)
					}

				} else {
					errores('Imagen')
					setCargandoBoton(false)
				}
			} else {
				errores('Precio')
				setCargandoBoton(false)
			}
		} else {
			errores('CampoVacio')
			setCargandoBoton(false)
		}

	}
	//console.log(error)
	const [activoSel, setActivoSel] = useState(false)

	const subeCombinacion = e => {

		if (atributoSelect.opciones.length > 1) {

			// setCombinacionAtri([
			// 	...combinacionAtri,
			// 	atributoSelect
			// ])

			setProductoSelect({
				...productoSelect,
				atributos: [...productoSelect.atributos, atributoSelect]
			})

			setAtributoSelect({
				nombre: '',
				opciones: [],
				limite: null,
				multiple: 'unico'
			})

		} else console.log('campos vacios')
	}


	//sube o limina opcion al selecAtributo
	const subeOpcion = (opcion, index, color) => e => {

		atributoSelect.opciones.map((itemm) => {
			if (itemm.id === index) {

				let newArr = atributoSelect.opciones.filter(function (el) { return el.id != index; });
				setAtributoSelect({ ...atributoSelect, opciones: newArr })

			} else {
				setAtributoSelect({
					...atributoSelect,
					opciones: [...atributoSelect.opciones, { opcion: opcion, id: index, color: color }]
				})
			}
		})

	}

	const subePrecioAtributo = (index, e) => {
		atributoSelect.opciones.map((itemm, indexx) => {
			if (itemm.id === index) {
				let copia = atributoSelect.opciones
				copia.map(item => {
					if (item.id === index) {
						item.id = item.id
						item.opcion = item.opcion
						item.precio = e.target.value
						item.color = item.color
					}
				})
				setAtributoSelect({
					...atributoSelect, opciones: copia
				})
				//console.log('atributoIn:', [...atributoSelect.opciones, {...itemm, precio: e.target.value}])
			}
		})
	}

	const ActivaInputAtri = (id) => {
		let resultado = false
		atributoSelect.opciones.map(item => {
			if (item.id === id) { resultado = true }
		})
		return resultado
	}

	const SeleccionaAtributo = nombre => {

		let NuevoArray = []
		atributos.map((item) => {
			if (item.padre === nombre) {
				NuevoArray.push(item.nombre)
			}
		})

		setAtributoSelect({
			...atributoSelect,
			nombre: nombre,
			opciones: [""],
			limite: null,
			multiple: ''
		})
		setActivoSel(false)

	}

	const eliminaCombinacion = (nombre, index) => e => {
		e.preventDefault()

		let newArr = productoSelect.atributos
		const eliminado = newArr.splice(index, 1)
		eliminado.map(item => setAtributosEliminados([...atributosEliminados, item]))

		setProductoSelect({ ...productoSelect, atributos: newArr })
	}


	const RecibeBusqueda = e => {

		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {

		if (termino === '') {
			console.log('nada...', termino)
			setDataFiltrado([...copiaArray].splice(0, PAGINACION))
		} else {
			let resultado = copiaArray.filter((item) => {
				if (item.nombre_producto.toLowerCase().includes(termino.toLowerCase()) || item.id.toLowerCase().includes(termino.toLowerCase()) || item.referencia.toLowerCase().includes(termino.toLowerCase())) {
					return item
				}
			})
			setDataFiltrado(resultado)
		}
	}

	const ReiniciarPaginacion = () => {
		setDataFiltrado([...data].splice(0, PAGINACION))
		setBusqueda('')
	}


	const [isPrinting, setIsPrinting] = useState(false);
	const printRef = useRef(null);

	// We store the resolve Promise being used in `onBeforeGetContent` here
	const promiseResolveRef = useRef(null);

	// We watch for the state to change here, and for the Promise resolve to be available
	useEffect(() => {
		if (isPrinting && promiseResolveRef.current) {
			// Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
			promiseResolveRef.current();
		}
	}, [isPrinting]);

	const handlePrint = useReactToPrint({
		content: () => refImprimirProductos.current,
		onBeforeGetContent: () => {
			return new Promise((resolve) => {
				promiseResolveRef.current = resolve;
				setIsPrinting(true);
			});
		},
		onAfterPrint: () => {
			// Reset the Promise resolve so we can print again
			promiseResolveRef.current = null;
			setIsPrinting(false);
		}
	});


	const cambiarCheckboxVisualizacion = (event) => {
		const target = event.target;
		const name = target.name;

		if (visualizacionState.includes(name)) {
			const filtrarArray = visualizacionState.filter(function (e) { return e !== name })
			setVisualizacionState(filtrarArray)
		} else {
			setVisualizacionState([...visualizacionState, name])
		}
	}

	const validarCheckboxVisualizacion = (name) => visualizacionState.includes(name)

	const handleCambiarProductosCombos = (nombre, dato, i) => {
		let productos = [...productosEnCombo];
		productos[i] = { ...productos[i], [nombre]: dato };

		setProductosEnCombo(productos)
	}


	const handleCrearProductosCombos = () => {
		setProductosEnCombo([...productosEnCombo, {
			"id": uid(),
			"cantidad": null,
			"producto": null,
			"atributos": null,
			"opciones": null
		}])
	}

	const handleOnEliminarProductosCombos = i => {
		const newArray = productosEnCombo.filter((person) => person.id !== i);
		setProductosEnCombo(newArray);
	}
	const cambiarCheckboxCombos = () => {
		setProductoSelect({ ...productoSelect, atributos: [] })
		setCheckCombos(!checkCombos);
	}

	return (
		<div>
			<Header
				funcion={funcion}
				setFuncion={setFuncion}
				barcode
				titulo={funcion === 'barcode' ? 'Impresión de Códigos de Barras' : Titulo}
				RecibeBusqueda={RecibeBusqueda}
				busqueda={busqueda}
				resetBusq={ReiniciarPaginacion}
			>
				<button
					onClick={handlePrint}
					className="btn boton_estandar btn-lg derecha">
					<FontAwesomeIcon icon={faPrint} size='lg' />
				</button>
				<button
					onClick={handleDownloadExcel}
					className="btn boton_estandar btn-lg derecha">
					<FontAwesomeIcon icon={faFileExcel} size='lg' />
				</button>
			</Header>


			{funcion === 'eliminar' ?

				<EliminarProducto productoSelect={productoSelect} peticionDelete={peticionDelete} setFuncion={setFuncion} />
				: null}

			{funcion === 'cargando' ?
				<div className="loader">Loading...</div>
				: null}

			{funcion === 'ver' ?
				<>

					<div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>

						<div style={{ alignItems: 'flex-end' }}>
							<Paginacion
								data={data}
								setDataFiltrado={setDataFiltrado}
								PAGINACION={PAGINACION}
								numPaginas={numPaginas}
								paginaAct={paginaAct}
								setPaginaAct={setPaginaAct}
							/>
						</div>
					</div>

					<VerProductos
						data={dataFiltrado}
						imprimeArray={imprimeArray}
						seleccionaProducto={seleccionaProducto}
						baseUrl={baseUrl}
					/>
				</>
				: null}
			{funcion === 'editar' ?

				<div>
					<div>
						<br />
						<h4>Editar Producto:</h4>
					</div>
					<MDBContainer>
						<MDBRow>
							<MDBCol>
								<hr />
								{error.activo ?
									<span className="error"> Error: {error.mensaje}</span> : null
								}


								<div className='custom-control custom-switch '>
									<input
										type='checkbox'
										name="activo"
										className='custom-control-input form-control-lg mb-4'
										id='customSwitches'
										checked={productoSelect.activo}
										onChange={e => setProductoSelect({ ...productoSelect, activo: e.target.checked })}
										readOnly
									/>
									<label className='custom-control-label' htmlFor='customSwitches'>
										Activar/Desactivar
									</label>
								</div>


								<div className="row">

									<div className="col-md-9">

										<MDBInput label="Nombre Producto" outline
											value={productoSelect.nombre_producto}
											onChange={e => setProductoSelect({ ...productoSelect, nombre_producto: e.target.value })}
										/>

										<div className="row">

											<div className="col-md-4">
												<label>Tipo Producto</label>
												<select className="browser-default custom-select"
													value={productoSelect.tipo}
													onChange={e => setProductoSelect({ ...productoSelect, tipo: e.target.value })}>
													<option value="">Selecciona Tipo de Producto</option>
													<option value="Curso">Curso</option>
													<option value="Producto">Producto</option>
												</select>
											</div>
											{productoSelect.tipo === 'Curso' ?
												<div className="col-md-4">
													<label>Selecciona Curso</label>
													<select className="browser-default custom-select"
														value={productoSelect.curso}
														onChange={e => setProductoSelect({ ...productoSelect, curso: e.target.value })}>
														<option>Selecciona Curso</option>
														{cursos.map(item => {
															return (
																<option key={item.id} value={item.nombre}>{item.nombre}</option>
															)
														})}
													</select>

												</div>
												: null}

											<div className="col-md-4">
												<label>Referencia</label>
												<div className="md-form md-outline m-0">
													<input
														type='text'
														required
														placeholder='Referencia'
														className="form-control"
														value={productoSelect.referencia}
														onChange={e => setProductoSelect({ ...productoSelect, referencia: e.target.value })}
													/>
												</div>
											</div>

											<div className="col-md-4">
												<label>Precio Normal</label>
												<div className="md-form md-outline m-0">
													<input
														type='number'
														placeholder='Precio Normal'
														required
														className="form-control"
														value={productoSelect.precio_producto}
														onChange={e => setProductoSelect({ ...productoSelect, precio_producto: e.target.value })}
													/>
												</div>
											</div>
										</div>

										<div className="form-group">
											<label for="exampleFormControlTextarea1">Descripción:</label>
											<textarea
												value={productoSelect.descripcion}
												onChange={e => setProductoSelect({ ...productoSelect, descripcion: e.target.value })}
												className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
										</div>

										<h5>Categorías:</h5>

										{
											categorias.map((item, index) => {

												if (item.nombre !== 'todo') {
													return (
														<div className="custom-control custom-checkbox custom-control-inline" key={index}>
															<input type="checkbox" className="custom-control-input" name={item.id} id={item.nombre}
																checked={consultaCategoria(productoSelect.categoria_producto, item.id)}
																onChange={subeCategorias(item.id, index)} />
															<label className="custom-control-label" htmlFor={item.nombre}>{item.nombre}</label>
														</div>
													)
												}
											})
										}

										<div className='mt-2'>
											<h5>Visualización:</h5>

											<div className="custom-control custom-checkbox custom-control-inline">
												<input onChange={cambiarCheckboxVisualizacion} type="checkbox" className="custom-control-input" id="App" name='App' defaultChecked={validarCheckboxVisualizacion('App')} />
												<label className="custom-control-label" htmlFor="App">App</label>
											</div>
											<div className="custom-control custom-checkbox custom-control-inline">
												<input onChange={cambiarCheckboxVisualizacion} type="checkbox" className="custom-control-input" id="Facturación" name='Facturación' defaultChecked={validarCheckboxVisualizacion('Facturación')} />
												<label className="custom-control-label" htmlFor="Facturación">Tienda Física</label>
											</div>
											<div className="custom-control custom-checkbox custom-control-inline">
												<input onChange={cambiarCheckboxVisualizacion} type="checkbox" className="custom-control-input" id="Tienda" name='Tienda' defaultChecked={validarCheckboxVisualizacion('Tienda')} />
												<label className="custom-control-label" htmlFor="Tienda">Página web</label>
											</div>

										</div>
										<div className='mt-2'>
											<h5>Combos:</h5>

											<div className='custom-control custom-switch '>
												<input type='checkbox' name="combos" className='custom-control-input form-control-lg mb-4' id='combos'
													checked={checkCombos}
													onChange={cambiarCheckboxCombos}
												/>
												<label className='custom-control-label' htmlFor='combos'>Activar Combos</label>
											</div>

										</div>

										{checkCombos ?
											productosEnCombo.map((pro, index) => (
												<FieldsProductosCombos i={index} key={pro.id} value={pro} onChange={handleCambiarProductosCombos} copiaArray={copiaArray} baseURLInventarios={baseURLInventarios} onClick={handleCrearProductosCombos} onRemove={handleOnEliminarProductosCombos} ultimo={productosEnCombo.length - 1 === index} primero={productosEnCombo.length == 1} />
											))
											:
											<div className="row">
												<div className="col-md-12"></div>

												<div className="col-md-12"><hr /></div>
												<div className="col-md-5">
													<h5>Atributos:</h5>

													<select className="browser-default custom-select campos_atributos"
														value={atributoSelect.nombre}
														onChange={e => SeleccionaAtributo(e.target.value)}>
														<option value="">Selecciona Tipo de Atributo</option>
														{
															atributos.map((item, index) => {
																if (item.padre === "")
																	return (
																		<option key={index} value={item.nombre}>{item.nombre}</option>
																	)
															})
														}
													</select>

													<p>Selecciona todas las opciones:</p>
													{
														atributos.map((item, index) => {
															if (item.padre !== "" && atributoSelect.nombre === item.padre)
																return (
																	<div style={{ display: 'flex' }}>
																		<div className="custom-control custom-checkbox contBoxAtri">
																			<input type="checkbox" className="custom-control-input" id={item.nombre}
																				name={item.nombre}
																				onChange={subeOpcion(item.nombre, index, item.color)} />
																			<label className="custom-control-label" for={item.nombre}>{item.nombre}</label>
																		</div>
																		<div className='contInputPrecioAtri'>
																			{ActivaInputAtri(index) ?
																				<input onChange={e => subePrecioAtributo(index, e)} className="form-control" type='number' placeholder='precio'></input>
																				: null}
																		</div>

																	</div>

																)
														})
													}


													<div className="text-center mt-4">
														<div className="col text-center">
															<button
																onClick={subeCombinacion}
																className="btn boton_estandar"
															>Crear combinación
															</button>
														</div>
													</div>


												</div>

												<div className="col-md-7">
													<h5>Combinaciones:</h5>

													{
														productoSelect.atributos.map((item, index) => {
															return (

																<div className="combinacion" key={index}>

																	<div className="row">
																		<div className="col-md-9">
																			<h6>{item.nombre}</h6>
																			<p><span>{imprimeAtribut(item.opciones, false)}</span></p>
																			<p>{item.limite !== null ? <b>Limite: </b> : null}
																				{item.limite !== null ? item.limite : null}
																			</p>

																		</div>
																		<div className="col-md-3">
																			<div className="col text-center">
																				<button
																					onClick={eliminaCombinacion(item.nombre, index)}
																					className="btn boton_estandar_blanco"
																				><FontAwesomeIcon icon={faTrashAlt} size="lg" />
																				</button>
																			</div>
																		</div>
																	</div>


																</div>
															)
														})
													}

												</div>


											</div>
										}
										<div className='custom-control custom-switch '>
											<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='invent'
												checked={checkInvent}
												onChange={e => { setCheckInvent(!checkInvent); }}
											/>
											<label className='custom-control-label' htmlFor='invent'>Activar Inventario Avanzado</label>
										</div>

										<div className='custom-control custom-switch '>
											<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='descuento'
												checked={checkDescuentoCupones}
												onChange={e => { setCheckDescuentoCupones(!checkDescuentoCupones); }}
											/>
											<label className='custom-control-label' htmlFor='descuento'>Descuento por cupones</label>
										</div>

										{checkInvent && (<div className="row mt-3">
											<div className="col-md-4"><h5>Alertas:</h5> <p className="estados Rojo">Por agotarse</p></div>
											<div className="col-md-8">

												<MDBInput label="Minimo Stock " outline
													value={alerta}
													onChange={e => setAlerta(e.target.value)} />
											</div>
										</div>)}

										<br />
									</div>

									{/* COLUMNA DERECHA ------------------------------------ */}
									<div className="col-md-3">
										<div className="form-group">
											<AgregarImagenes
												imagenes={imagenes}
												setImagenes={setImagenes}
												setImagenesNuevas={setImagenesNuevas}
												setBorraImagenes={setBorraImagenes} />
										</div>
										<hr></hr>

										<h5>Gestión de Envios:</h5>
										<p style={{ fontSize: 13 }}>Las cargas se asignan según el tamaño o ucupación que tiene dicho producto para ser enviado, puedes usar decimales.</p>
										<MDBInput label="Cargas" outline
											type='number'
											value={productoSelect.carga === '-1' ? null : productoSelect.carga}
											onChange={e => setProductoSelect({ ...productoSelect, carga: e.target.value })}
										/>
										<MDBInput label="% Descuento para Usuario" outline
											type='number'
											value={productoSelect.descuentouser}
											onChange={e => setProductoSelect({ ...productoSelect, descuentouser: e.target.value })}
										/>
									</div>

								</div>

								{/* ------recetas-------- */}

								<div><hr /></div>
								<div className="text-center mt-4">
									<div className="col text-center">
										<button
											onClick={peticionPut}
											disabled={cargandoBoton}
											className="btn boton_estandar"
										>{cargandoBoton && (<div className="spinner-border spinner-border-sm text-light" role="status">
											<span className="sr-only">Loading...</span>
										</div>)}Actualizar Producto
										</button>
										<button
											onClick={e => setFuncion('ver')}
											className="btn boton_estandar"
										>Cancelar
										</button>
									</div>
								</div>
							</MDBCol>
						</MDBRow>
					</MDBContainer>
				</div>

				: null}
			{funcion === 'crear' ?
				<SubirProductos
					copiaArray={copiaArray}
					baseURLInventarios={baseURLInventarios}
					baseUrl={baseUrl}
					baseUrlCursos={baseUrlCursos}
					nombreImpuesto={nombreImpuesto}
					urlCat={urlCat}
					urlAtributos={urlAtributos}
					Titulo={'Subir Productos'}
					setFuncion={setFuncion}
					dataFiltrado={dataFiltrado}
					setDataFiltrado={setDataFiltrado}
				/>
				: null}
			{funcion === 'barcode' ? <ProductosBarcode
				dataFiltrado={dataFiltrado}
				productos={productosBarcode}
				setDataFiltrado={setDataFiltrado}
				PAGINACION={PAGINACION}
				numPaginas={numPaginas}
				paginaAct={paginaAct}
				setPaginaAct={setPaginaAct} /> : null}


			{
				funcion === 'alertas' && (
					<InventarioProductosConfiguracion setFuncion={setFuncion} productoSelect={productoSelect} baseUrl={baseUrl} data={data} setData={setData} />
				)
			}

			<div style={{ display: "none" }}>	<ImprimirProductos ref={refImprimirProductos} data={data} imprimeArray={imprimeArray} /> </div>
		</div>
	)
}

export default ProductosAdmin